import keyMirror from 'keymirror'

export default keyMirror({
  GET_LIST_KIT_CONFIGURATION_VERSION_PERS_REQUEST: null,
  GET_LIST_KIT_CONFIGURATION_VERSION_PERS_SUCCESS: null,
  GET_LIST_KIT_CONFIGURATION_VERSION_PERS_FAILED: null,

  GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_REQUEST: null,
  GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_SUCCESS: null,
  GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_FAILED: null,

  DELETE_KIT_CONFIGURATION_VERSION_PERS_REQUEST: null,
  DELETE_KIT_CONFIGURATION_VERSION_PERS_SUCCESS: null,
  DELETE_KIT_CONFIGURATION_VERSION_PERS_FAILED: null,

  ADD_KIT_CONFIGURATION_VERSION_PERS_REQUEST: null,
  ADD_KIT_CONFIGURATION_VERSION_PERS_SUCCESS: null,
  ADD_KIT_CONFIGURATION_VERSION_PERS_FAILED: null,

  UPDATE_KIT_CONFIGURATION_VERSION_PERS_REQUEST: null,
  UPDATE_KIT_CONFIGURATION_VERSION_PERS_SUCCESS: null,
  UPDATE_KIT_CONFIGURATION_VERSION_PERS_FAILED: null
})
